import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;
const Introduction = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className='Title2' style={{color: appColors['ColorNa'], fontSize: '8vh'}}>Project implementation</Paragraph>
        <Paragraph className= 'Title3' style={{color: appColors['ColorX'], marginTop: '-7vh'}}>Introduction</Paragraph>
        <Text className='BaseText2'>To implement iMoAge in the real world, multiple hurdles must be overcome, including validation of end-users, accessible distribution channels, legislation, certifications, and safety aspects. In this section, the proposed implementation of iMoAge is discussed and the challenges that arise from this proposition are addressed.</Text>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default Introduction;
